import { NotesWriter } from "@/components/NotesWriter/NotesWriter";
import { LayoutWorkstationHeader } from "@/components/_layouts/LayoutWorkstationHeader/LayoutWorkstationHeader";
import { LayoutWorkstationSidebar } from "@/components/_layouts/LayoutWorkstationSidebar/LayoutWorkstationSidebar";
import { useIsPlanInactive } from "@/hooks/useIsPlanInactive";
import { DealRecord, getCurrentDealEntity } from "@/models/deal";
import { PartialEntityRecord } from "@/orm/types";
import { ScrollArea, Stack } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import { useAsync } from "react-async-hook";
import { Contacts } from "./Contacts";
import { EditDealForm } from "./EditDealForm";
import { Header } from "./Header";

export const Main = () => {
  const { inactiveElementProps } = useIsPlanInactive();
  const viewPortSize = useViewportSize();

  return (
    <LayoutWorkstationHeader header={<Header />}>
      <LayoutWorkstationSidebar
        align="right"
        sidebar={<NotesWriter entity={getCurrentDealEntity()} />}
        size={viewPortSize.width < 1375 ? "md" : "xl"}
        {...inactiveElementProps}
      >
        <ScrollArea h={"100%"} w={"100%"}>
          <Stack p="sm">
            <EditDeal />
            <Contacts />
          </Stack>
        </ScrollArea>
      </LayoutWorkstationSidebar>
    </LayoutWorkstationHeader>
  );
};

const EditDeal = () => {
  const entity = getCurrentDealEntity();
  const { result: deal } = useAsync(entity.hydrate, []);

  const onValuesChange = (values: PartialEntityRecord<DealRecord>) => {
    entity.update({
      companyName: values.companyName,
      location: values.location,
      industry: values.industry,
      listingLink: values.listingLink,
      brokerage: values.brokerage,
      broker: values.broker,
      purchasePrice: values.purchasePrice || null,
      revenue: values.revenue || null,
      cashFlow: values.cashFlow || null,
      establishedAt: values.establishedAt,
    });
  };

  if (!deal) return null;

  return (
    <Stack>
      <EditDealForm initialValues={deal} onValuesChange={onValuesChange} />
    </Stack>
  );
};
